import ApiService from '@/services/core/api.service'

const ReservationService = {
  async get (query) {
    return ApiService.get(`user/reservations?${query}`)
  },

  async histories (query) {
    return ApiService.get(`user/reports/reservation-histories?${query}`)
  },

  async post (payload) {
    return ApiService.post('user/reservations', payload)
  },

  async put (payload) {
    return ApiService.put(`user/reservations/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`user/reservations/${payload.id}`)
  },

  async cancel (payload) {
    return ApiService.put(`user/actions/cancel-reservation/${payload.id}`, payload)
  }
}

export default ReservationService
